<div class="body">

    <div *ngIf="(service.offers$|async)?.length > 0; else noOffers" class="content">

        <table mat-table [dataSource]="service.offers$|async" class="table" matSort (matSortChange)="sortData($event)">

            <ng-container matColumnDef="number">
                <th mat-header-cell mat-sort-header="offernumber" *matHeaderCellDef>Nummer</th>
                <td mat-cell *matCellDef="let element" (click)="ref.focus()">

                    <input class="input very-tight" matInput #ref [value]="element.offernumber" readonly />

                </td>
            </ng-container>

            <ng-container matColumnDef="title">
                <th mat-header-cell mat-sort-header="offertitle" *matHeaderCellDef>Bezeichnung</th>
                <td mat-cell *matCellDef="let element" (click)="ref.focus()">

                    <input class="input very-tight" matInput #ref [value]="element.offertitle" readonly />

                </td>
            </ng-container>

            <ng-container matColumnDef="status">
                <th mat-header-cell mat-sort-header="offerstate" *matHeaderCellDef>Status</th>
                <td mat-cell *matCellDef="let element">

                    <div>{{element.offerstate|offerStatus|async}}</div>

                </td>
            </ng-container>

            <ng-container matColumnDef="itemCount">
                <th class="padding-header" mat-header-cell mat-sort-header="offeritem" *matHeaderCellDef>Artikel</th>
                <td mat-cell *matCellDef="let element">

                    <div>{{element.offeritem? element.offeritem.length: 0}}</div>

                </td>
            </ng-container>

            <ng-container matColumnDef="options">
                <th mat-header-cell *matHeaderCellDef>Optionen</th>
                <td mat-cell *matCellDef="let element">

                    <button mat-icon-button (click)="navigateToOfferDetails(element)">
                        <mat-icon>search</mat-icon>
                    </button>

                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="columns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: columns;" class="body-row"></tr>

        </table>

    </div>

</div>

<ng-template #noOffers>

    <div class="no-offers-hint">

        <span>Keine Angebote gefunden</span>

    </div>

</ng-template>
